module.exports = __webpack_public_path__ + "img/3f_r_pizzala.a6fe48a5.png";